import { createStateHook } from '@atlassian/react-sweet-state';
import type { Actions } from './actions.tsx';
import { ArchiveIssueModalStore } from './main.tsx';
import type { State } from './types.tsx';

export const useArchiveIssueModalStates = createStateHook<State, Actions>(ArchiveIssueModalStore);
